import path from 'path'
import mapValues from 'lodash/mapValues'

export const PageHeaderRoutes = {
  data() {
    return {
      isShowingMainMenu: false
    }
  },

  computed: {
    mainMenuLabel() {
      return this.isShowingMainMenu ? 'Close Main Menu' : 'Open Main Menu'
    },

    routes() {
      const list = {
        account: {
          location: { name: `account` },
          options: { last: true }
        },
        signIn: {
          location: {
            name: 'sessions.sign-in',
            query: { next: path.join(this.$router.history.base, this.$route.fullPath) }
          },
          options: {}
        },
        docs: {
          location: { name: `latest.docs`, params: { pathMatch: '' } },
          options: {}
        },
        icons: {
          location: { name: `latest.icons` },
          options: {}
        },
        kits: {
          location: { name: `kits` },
          options: {}
        },
        plans: {
          location: { name: `plans` },
          options: {}
        },
        search: {
          location: { name: 'latest.search' },
          options: {}
        },
        start: {
          location: { name: `start` },
          options: {}
        },
        support: {
          location: { name: `support` },
          options: {}
        }
      }

      return mapValues(list, (item) => {
        const { location, options } = item
        let active = (this.$route.name || '').indexOf(location.name) === 0

        if (this.$router.history.base === '/docs' && location.name === 'latest.docs') {
          active = true
        }

        return {
          location,
          active,
          options
        }
      })
    }
  },

  methods: {
    toggleMainMenu() {
      this.isShowingMainMenu = !this.isShowingMainMenu
    }
  }
}
